import http from "../http-common";

const getAll = (loc) => {
  return http.get(`/v1/cards/issued`);
};

const get = (id) => {
  return http.get(`/v1/cards/issued/id/${id}`);
};

const create = (data) => {
  return http.post("/v1/cards/issued", data);
};

const update = (id, data) => {
  return http.put(`/v1/cards/issued/id/${id}`, data);
};

const remove = (id) => {
  return http.delete(`/v1/cards/issued/id/${id}`);
};

const removeAll = () => {
  return http.delete(`/v1/cards/issued`);
};

const findByName = (name) => {
  return http.get(`/v1/cards/issued?name=${name}`);
};

export default {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByName,
};
